export const NOTIFICATION_TOP_LEFT = 'top-left'
export const NOTIFICATION_TOP_RIGHT = 'top-right'
export const NOTIFICATION_BOTTOM_LEFT = 'bottom-left'
export const NOTIFICATION_BOTTOM_RIGHT = 'bottom-right'

export const NotificationPositions = [
  NOTIFICATION_TOP_LEFT,
  NOTIFICATION_TOP_RIGHT,
  NOTIFICATION_BOTTOM_LEFT,
  NOTIFICATION_BOTTOM_RIGHT
]

export type NotificationPositionType = typeof NotificationPositions[number]

export const NOTIFICATION_TYPE_PRIMARY = 'primary'
export const NOTIFICATION_TYPE_PRIMARY_DARK = 'primary-dark'
export const NOTIFICATION_TYPE_PRIMARY_INVERT = 'primary-invert'
export const NOTIFICATION_TYPE_ERROR = 'error'
export const NOTIFICATION_TYPE_DEFAULT = 'default'

export const NotificationTypes = [
  NOTIFICATION_TYPE_PRIMARY,
  NOTIFICATION_TYPE_PRIMARY_DARK,
  NOTIFICATION_TYPE_PRIMARY_INVERT,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_DEFAULT
]

export type NotificationTypeType = typeof NotificationTypes[number]
